import React from "react";
import { TextChoiceAnswerFormat } from "../../../../types/Survey";
import TextChoiceList from "../../Components/TextChoiceList/TextChoiceList";
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let answerFormat = props.answerFormat as TextChoiceAnswerFormat;
    let currentResult = props.result as QuestionResultModel;

    return <SurveyFormItem
        label={props.label}
        labelPosition="top"
        variant={props.variant}
        useFieldsetFormat={props.useFieldsetFormat}
        index={props.index}>
        <TextChoiceList
            variant={props.variant}
            textChoices={answerFormat.textChoices}
            style={answerFormat.style}
            selectedChoices={currentResult.Answers}
            onChangeChoices={(choices) => props.onResultChange({ ...props.result, Answers: choices } as QuestionResultModel)}
            descriptionStyle={answerFormat.descriptionStyle}
            bubbleAlignment={answerFormat.bubbleAlignment} />
    </SurveyFormItem>;
}